import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { PersonnelActions } from './personnel.actions';
import { catchError, mergeMap, of } from 'rxjs';
import { PersonnelEntity } from './personnel.entity';
import { Helper } from '@portal/util';
import { PersonnelModel } from '../../model';
import { PersonnelJwt } from '../data-access.store';
import { jwtDecode } from 'jwt-decode';
import { PersonnelEntityState } from '../../type';

@Injectable()
export class PersonnelEffects {
  private readonly actions$ = inject(Actions);

  private readonly init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PersonnelActions.init),
      mergeMap(action => {
        const { personnelId }: PersonnelJwt = jwtDecode(action.accessToken);
        const entities = this.getEntities(action.personnels);
        const personnel = entities.find(v => v.data.id === personnelId);

        return of(PersonnelActions.loadSuccess({ entities, selectedId: personnel?.id }));
      }),
      catchError(error => {
        console.error('Error', error);
        return of(PersonnelActions.loadFailure({ error }));
      }),
    ),
  );

  private getEntities(personnels: PersonnelModel[]): PersonnelEntity[] {
    return personnels.map<PersonnelEntity>(personnel => {
      const id = Helper.randomId(4);
      return {
        data: PersonnelModel.fromJson({ ...personnel, entityState: PersonnelEntityState.Existed, entityId: id }),
        state: PersonnelEntityState.Existed,
        id,
      };
    });
  }
}
